import { Injectable } from '@angular/core';

import { Observable, Subject, of } from 'rxjs';

import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { ControlPropertyHandler } from './control-property-handler';
import { AbstractPropertyEditor } from '../types';

@Injectable({
  providedIn: 'root'
})
export class TemplateNamePropertyService implements ControlPropertyHandler<any> {
  propertyName: string = 'templateName';

  constructor(private commonConfig: DynamicFormCommonConfig) {}

  handleData(data: any, editor: AbstractPropertyEditor): Observable<any> {
    const sub = new Subject<string>();
    if (!data.trim() && data !== '') {
      this.commonConfig.log.error(`ä¸è½å¨ä¸ºç©ºæ ¼`);
      sub.error('');
      sub.complete();
      return sub;
    }

    return of(data);
  }
}
